import styled from 'styled-components';

export const Container = styled.div`
	background: var(--surface-canvas);
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;

	.entrar {
		background: var(--action-accent-surface);
		width: 15em;
		height: 4em;
		border: none;
		margin: 30px 0 0 0;
	}

	p {
		height: 0;
	}
	.userInvalid {

		margin-bottom: 25px;

		span {
			color: var(--error-text);
		}

	}
`;

export const CardContent = styled.div`
	background: var(--surface-raised);
	width: 50%;
	max-width: 640px;
	min-width: 360px;
	border-radius: 10px;
	min-height: 465px;
`;

export const CardHeader = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	padding: 30px 0px;
`;
export const CardBody = styled.div`
	width: 100%;
	padding: 5%;
	min-width: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const Title = styled.h4`
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
`;

export const HeaderModal = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const ContentModal = styled.div`
	padding: 15px;
	width: 55vw;
	margin-left: 25%;
	margin-top: 5%;
	background: var(--surface-raised);
	border: 2px solid var(--border-hairline);
	box-shadow: 24px;
	border-radius: 10px;
`;

export const SubTitle = styled.span`
	line-height: 24px;
	letter-spacing: 0.5px;
	color: var(--text-primary);
	display: inline-block;
	margin-bottom: 20px;
`;

export const Logo = styled.img`
	/* Só a altura é fixada; a largura acompanha e a proporção fica intacta (FR-010). */
	height: 40px;
	width: auto;
	display: block;
`;
